import { Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export const ConfirmDelete = ({ onConfirm, title = "Confermi l'eliminazione?", text = "L'operazione non può essere annullata.", testid, label, confirmLabel, icon: Icon = Trash2, tone = "rose" }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <Button variant={label ? "outline" : "ghost"} size={label ? "sm" : "icon"} data-testid={testid} className={tone === "rose" ? "text-rose-600 hover:bg-rose-50 hover:text-rose-700" : "bg-white text-sky-700 hover:bg-sky-50"}>
        <Icon className="h-4 w-4" />{label && <span className="ml-1.5">{label}</span>}
      </Button>
    </AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{text}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-cancel">Annulla</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete" className={tone === "rose" ? "bg-rose-600 hover:bg-rose-700" : "bg-sky-600 hover:bg-sky-700"} onClick={onConfirm}>{confirmLabel || "Elimina"}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
